import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import NavLink from './nav-link';
import ChildLink from './child-link';
import HeaderWrapper from './header-wrapper';
import CloseButton from './close-button';
import NavItem from './nav-item';
import Wrapper from './wrapper';
import Addons from './addons';
import Backdrop from './backdrop';
import Children from './children';
import activeClassName from '../activeClassName';
import useMenuItems from '../../../hooks/use-menu-items';
import useActiveMenu from '../../../hooks/use-active-menu';

const CoverNav = ({
  className,
  pageId = null,
  mustHaveSubpages = false,
}) => {
  const { menus } = useMenuItems();
  const { items, title, position } = menus[0];
  const menuName = `${title} (${position})`;

  // you can provide a custom pageId to active a menu item
  // for example, a category pageId for detail pages
  const activeMenu = useActiveMenu({ pageId, mustHaveSubpages });

  return (
    <>
      <BodyLockStyles />
      <Backdrop menuName={menuName} />
      <nav className={className}>
        <HeaderWrapper>
          <CloseButton menuName={menuName} />
        </HeaderWrapper>
        <Wrapper>
          {items && items.length > 0 && items.map(({
            id,
            page,
            subpages = [],
            externalpage,
            icon,
          }) => (
            <NavItem key={id}>
              {(page || externalpage) && (
                <NavLink
                  menuName={menuName}
                  activeClassName={activeClassName}
                  className={(page?.slug && page.slug === activeMenu?.page?.slug) ? activeClassName : ''}
                  to={externalpage?.externalLink || page?.slug}
                  as={externalpage?.externalLink === '#' ? 'span' : null}
                >
                  {externalpage?.externalTitle || page?.title}
                  {icon && (
                    <Image image={icon} />
                  )}
                </NavLink>
              )}
              {subpages && subpages.length > 0 && (
                <Children>
                  {subpages.map(({ preview, ...subpage }) => (
                    <ChildLink
                      key={subpage.id}
                      menuName={menuName}
                      activeClassName={activeClassName}
                      partiallyActive
                      to={preview?.page?.slug || subpage.slug || subpage.externalLink}
                    >
                      {preview?.title || subpage.title || subpage.externalTitle}
                    </ChildLink>
                  ))}
                </Children>
              )}
            </NavItem>
          ))}
        </Wrapper>
        <Addons />
      </nav>
    </>
  );
};

const BodyLockStyles = createGlobalStyle`
  body {
    overflow: hidden !important;
  }
`;

export default styled(CoverNav)`
  z-index: 9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 50vw;
  right: 0;
  overflow-y: scroll;
  background-color: ${({ theme }) => theme.grayColor};

  @media all and (max-width: ${({ theme }) => theme.breakingpoints.sm}) {
    left: 0;
  }
`;
